// The player's own open search, for the header's Play timer.

export function getSearchListManager() {
	// Loaded on demand: the manager pulls in the store and socket-backed lists.
	return require('components/MatchSearchListManager').matchSearchListManager;
}

function findMyActiveSearchAndList(searchListManager) {
	for(const matchList of searchListManager.matchLists) {
		for(const match of matchList.matches.values()) {
			if(match.isMySearch() && match.isSearch && !match.is_removed) {
				return { match, matchList };
			}
		}
	}
	return null;
}

export function findMyActiveSearch(searchListManager = getSearchListManager()) {
	const found = findMyActiveSearchAndList(searchListManager);
	return found ? found.match : null;
}

// Ends the player's own open search (the same call as the search card's cancel).
export function stopMyActiveSearch(searchListManager = getSearchListManager()) {
	const found = findMyActiveSearchAndList(searchListManager);
	if(!found) {
		return null;
	}
	return found.matchList.endMatchmaking(found.match.id);
}

// Seconds left on a search as m:ss. `true` means the search has no time limit.
export function formatSearchClock(secondsRemaining) {
	if(secondsRemaining === true) {
		return '∞';
	}
	const seconds = Math.max(0, Math.floor(secondsRemaining));
	const minutes = Math.floor(seconds / 60);
	return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}
